(function() {
  'use strict';

  function AnnouncementsController(
    RouterHelper,
    $rootScope,
    Announcements,
    AnnouncementsUtils,
    List,
    Security,
    $translate,
    Utils // Replaced Router with RouterHelper
  ) {
    var ctrl = this;

    Utils.setPageTitle('Announcements');

    /**
     * Return a list of possible actions the user can take in the list.
     * @param  {Boolean} showReorder Whether to show the Reorder action or not.
     * @return {Array}               A list of possible actions.
     */
    var getActions = function(showReorder) {
      var actions = [{
        label: $translate.instant('New'),
        icon: 'icon-edit',
        onClick: function() {
          RouterHelper.navigate(['/announcements/new']);
        },
        showCondition: Security.hasPermission.bind(this, 'announcements.edit'),
        klass: 'btn-success'
      }];

      if (showReorder) {
        actions.push({
          label: $translate.instant('Reorder'),
          icon: 'icon-move',
          onClick: function() {
            RouterHelper.navigate(['/announcements/reorder']);
          },
          showCondition: Security.hasPermission.bind(this, 'announcements.edit'),
          klass: 'btn-border btn-info'
        });
      }

      return actions;
    };

    ctrl.list = new List({
      search: AnnouncementsUtils.search,
      model: AnnouncementsUtils.searchModel,
      idField: '_id'
    });
    $rootScope.$broadcast(
      'KZCurrentListChange',
      { list: 'announcements', search: ctrl.list.search }
    );

    ctrl.options = {
      trackBy: '_id',
      borderClass: AnnouncementsUtils.getBorderClass
    };

    ctrl.$onInit = function() {
      Announcements.findAll({ cached: false })
        .then(function(items) {
          items = _.chain(items)
                  .sortBy(function(item) { return item.order; })
                  .value();

          var unOrderedAnnouncements = items.filter(function(item) {
            return AnnouncementsUtils.canBeReordered(item);
          });

          ctrl.actions = getActions(unOrderedAnnouncements.length > 1);

          ctrl.list.doLoadItems(items);
        });
    };
  }

  AnnouncementsController.$inject = [
    'RouterHelperService',
    '$rootScope',
    'AnnouncementsService',
    'AnnouncementsUtils',
    'ListFactory',
    'SecurityService',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.announcements')
    .controller('AnnouncementsController', AnnouncementsController);
})();
